<template>
<textarea class="otext" @input="updateHTML"></textarea>
</template>

<script>
export default {
  props:['value'],
  mounted: function () {
    this.$el.value = JSON.stringify(this.value)
  },
  methods: {
    updateHTML: function(e) {
      console.log( e.target.value)
      this.$emit('input', JSON.parse(e.target.value))
    }
  }
}
</script>

<style>
.otext {
  overflow:auto;
  border-radius:4px;
  border-color:#ffffff;
  font-size:16px;
  background-color:#ffffff;
  color:#000000;
}
</style>
